import { StockistPurchaseModel } from "../DTOs/Purchase/StockistPurchaseModel";
import { StockistPurchaseOrderItemModel } from "../DTOs/Purchase/StockistPurchaseOrderItemModel";
import { ajaxController } from "./AjaxController";

export class OrderAjaxController {
  private _ajaxController = ajaxController;
  private _orderEndpoint = "StockistPurchaseOrder"

  getStockistOrders() {
    return this._ajaxController.getNoCast<StockistPurchaseModel[]>(
      `${this._orderEndpoint}/orders`,
      {}
    )
  }

  getStockistOrderItems(purchaseOrderId: number) {
    return this._ajaxController.getNoCast<StockistPurchaseOrderItemModel[]>(
      `${this._orderEndpoint}/items/${purchaseOrderId}`,
      {}
    )
  }

  async downloadInvoice(orderId: number): Promise<void> {
    await this._ajaxController.downloadFile(
      `${this._orderEndpoint}/orders/${orderId}/invoice`,
      `Invoice_${orderId}.pdf`
    );
  }
}

export const orderAjaxController = new OrderAjaxController();